import React, { useEffect } from "react";
// import { useParams } from "react-router-dom";
import { ExitIcon } from "@100mslive/react-icons";
import {
  Box,
  Button,
  Flex,
  Text,
  textEllipsis,
} from "@100mslive/roomkit-react";
import { ToastManager } from "./Toast/ToastManager";
import { useAuth } from "../contexts/Auth";
import { Header } from "./Header";
import { useNavigation } from "./hooks/useNavigation";
import {
  defaultPreviewPreference,
  UserPreferencesKeys,
  useUserPreferences,
} from "./hooks/useUserPreferences";
import { getRoutePrefix } from "../common/utils";

const PostLeave = () => {
  const { setTourData } = useAuth();
  const navigate = useNavigation();
  // const { roomId, role } = useParams();
  const [previewPreference] = useUserPreferences(
    UserPreferencesKeys.PREVIEW,
    defaultPreviewPreference
  );

  useEffect(() => {
    setTimeout(() => {
      navigate("/");
      setTourData({});
    }, 10000);
  }, [navigate, setTourData]);

  return (
    <Flex direction="column" css={{ size: "100%" }}>
      <Box css={{ h: "$18", "@md": { h: "$17" } }} data-testid="header">
        <Header isPreview />
      </Box>
      <Flex
        justify="center"
        direction="column"
        align="center"
        css={{ bg: "$background_dim", flex: "1 1 0", position: "relative" }}
      >
        <Text variant="h2" css={{ fontWeight: "$semiBold" }}>
          👋
        </Text>
        <Text
          variant="h4"
          css={{
            color: "$on_surface_high",
            fontWeight: "$semiBold",
            mt: "$12",
          }}
        >
          You left the {getRoutePrefix() ? "stream" : "meeting room"}
        </Text>
        <Text
          variant="body1"
          css={{
            color: "$on_surface_medium",
            mt: "$8",
            fontWeight: "$regular",
            textAlign: "center",
          }}
        >
          Have a nice day
          {previewPreference.name && (
            <Box as="span" css={{ ...textEllipsis(100) }}>
              , {previewPreference.name}
            </Box>
          )}
          !
        </Text>
        <Flex css={{ mt: "$14", gap: "$10", alignItems: "center" }}>
          {/* <Text
            variant="body1"
            css={{ color: "$on_surface_medium", fontWeight: "$regular" }}
          >
            Left by mistake?
          </Text> */}
          {/* <Button
            onClick={() => {
              let previewUrl = "/preview/" + roomId;
              if (role) previewUrl += "/" + role;
              navigate(previewUrl);
              ToastManager.clearAllToast();
            }}
            data-testid="join_again_btn"
          >
            <ExitIcon />
            <Text css={{ ml: "$3", fontWeight: "$semiBold", color: "inherit" }}>
              Rejoin
            </Text>
          </Button> */}
          <Button
            variant="standard"
            onClick={() => {
              setTourData({});
              navigate("/");
              ToastManager.clearAllToast();
            }}
            data-testid="no_thanks_btn"
          >
            <ExitIcon />
            <Text css={{ ml: "$3", fontWeight: "$semiBold", color: "inherit" }}>
              Go To Home Page
            </Text>
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default PostLeave;
